<template>
  <category-list :categoryData="categoryData"></category-list>
</template>

<script>
import CategoryList from '../components/additional/CategoryList.vue'

export default {
  components: {
    CategoryList
  },
  data () {
    return {
      categoryData: {
        title: 'カテゴリ（業種）',
        apiUrl: '/job_categories/',
        description: false,
        parentName: true
      }}
  }
}
</script>